import { render, staticRenderFns } from "./index.vue?vue&type=template&id=68a9a19d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./nutritionalNeeds.scss?vue&type=style&index=0&id=68a9a19d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a9a19d",
  null
  
)

export default component.exports